// Round illustrated palm/sun/beach icon for the "Atpūtas ceļojumi" section header — replaces
// the thin outline beach-umbrella icon with a small colorful travel illustration, per the
// approved reference. No matching asset exists in public/img/illustrations, so this is drawn
// inline as SVG (sky-to-sand gradient circle, sun, two wave lines, a palm tree) rather than a
// bitmap, keeping it crisp at any size.
export function VacationIcon({ size = 72 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="vacation-icon-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#cdeaff" />
          <stop offset="1" stopColor="#ffe6b0" />
        </linearGradient>
      </defs>
      <circle cx="36" cy="36" r="36" fill="url(#vacation-icon-bg)" />
      <circle cx="49" cy="19" r="7" fill="#ffb703" />
      <path
        d="M6 54c6-4 12-4 18 0s12 4 18 0 12-4 18 0"
        stroke="#5bc0eb"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M6 61c6-4 12-4 18 0s12 4 18 0 12-4 18 0"
        stroke="#8fd7f4"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M30 58c0-10 2-18 6-24" stroke="#8a5a2b" strokeWidth="4" strokeLinecap="round" />
      <g fill="#2f9e5c">
        <path d="M36 34c-6-6-14-7-20-4 6 2 12 5 16 9z" />
        <path d="M36 34c-8-3-16-1-21 4 7 0 14 0 19-2z" />
        <path d="M36 34c-2-8 1-15 6-19-2 6-3 13-2 19z" />
        <path d="M36 34c4-7 11-10 18-9-5 3-10 7-13 12z" />
        <path d="M36 34c6-2 12 0 16 5-6-1-12-1-16 1z" />
      </g>
    </svg>
  );
}
